"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgJunctionExit(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "6 0 12 24" }, props),
        React.createElement("g", { fill: "currentColor", transform: "translate(6 4)" },
            React.createElement("path", { d: "M7.503 4.343v6h-3v-6z" }),
            React.createElement("path", { d: "M11.657 6L9.536 8.121 6 4.586 2.464 8.12.344 6 6 .343 11.657 6z" }),
            React.createElement("rect", { width: 4, height: 4, x: 4, y: 12, rx: 2 }))));
}
exports.default = tombacIcon_1.default('JunctionExit')(SvgJunctionExit);
//# sourceMappingURL=JunctionExit.js.map